import { render, staticRenderFns } from "./User.vue?vue&type=template&id=09623cec&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"
import style0 from "./User.vue?vue&type=style&index=0&id=09623cec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09623cec",
  null
  
)

export default component.exports